import { render, staticRenderFns } from "./OggoData.vue?vue&type=template&id=4f6c47a0&"
import script from "./OggoData.vue?vue&type=script&lang=js&"
export * from "./OggoData.vue?vue&type=script&lang=js&"
import style0 from "./OggoData.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports